import { FixFlowDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import {
  FixFlowProvider,
  useFixFlowProvider,
} from 'modules/contracts/components/FixFlow/FixFlowProvider'
import Loading from 'modules/layout/components/Page/Loading'

import FixFlowContent from './_FixFlowContent'

const Container = () => {
  const { canEdit, loadingPermissions, loadingCustomFields } = useFixFlowProvider()
  const { company } = useCurrentSession()
  const { data, loading: loadingFixFlow } = useQuery(FixFlowDocument, {
    variables: { companyId: company.id },
  })

  if (loadingPermissions || loadingCustomFields || loadingFixFlow) return <Loading />

  if (!canEdit) return <NotFound />

  const jobCatalogTreeFeatureEnabled = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_job_catalog_tree'
  )?.enabled

  return (
    <FixFlowContent
      jobCatalogTrees={data?.jobCatalog?.treesConnection?.nodes}
      jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
    />
  )
}

const FixFlow = () => {
  return (
    <FixFlowProvider>
      <Container />
    </FixFlowProvider>
  )
}

export default FixFlow
